import { isNil } from "lodash";

import type { ColumnsType, AnyObject } from "@similarweb/pro-logic-components";

import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";

import { SearchOverviewTexts } from "../../texts";
import type { BrandedSplitData } from "../../types";
import { CellWithLeftPadding } from "../OrganicPaidTable/styledComponents";
import { renderDomainCell, renderProgressBarCell } from "../TableCells/tableCells";

export const getBrandedSplitColumns = (): ColumnsType<AnyObject> =>
    [
        {
            title: <CellWithLeftPadding>{translate("analysis.source.search.overview.domain")}</CellWithLeftPadding>,
            dataIndex: "domain",
            width: 144,
            render: renderDomainCell,
        },
        {
            title: translate(SearchOverviewTexts.brandedVsNonBranded),
            width: 272,
            dataIndex: "chartData",
            render: (chartData: BrandedSplitData) => {
                if (isNil(chartData?.branded?.numericValue) || isNil(chartData?.nonBranded?.numericValue)) {
                    return NO_DATA_SIGN;
                }
                const { branded, nonBranded } = chartData;
                const brandedValue = branded.numericValue * 100;
                return renderProgressBarCell({
                    leftValue: branded.formattedValue,
                    rightValue: nonBranded.formattedValue,
                    percentageValue: brandedValue,
                });
            },
        },
    ] as ColumnsType<AnyObject>;
